module.exports = __webpack_public_path__ + "img/aar_aarmetaverse.19d9a20.png";